module.exports = __webpack_public_path__ + "static/media/mastercard.29cbd0e2.svg";